import store from 'vx/store'

export default {
	baumeToBrix(sugar) {
		if (! sugar) return sugar;

		if (store.state.simulatorSetup.active.sugar_units) {
			return parseFloat(sugar);
		}

		return (parseFloat(sugar) - 0.0181) / 0.5532;
	},

	brixToBaume(sugar) {
		if (! sugar) return sugar;

		if (store.state.simulatorSetup.active.sugar_units) {
			return parseFloat(sugar);
		}

		return (parseFloat(sugar) * 0.5532) + 0.0181;
	},

	celsiusToFahrenheit(temperature) {
		if (! temperature) return temperature;

		if (store.state.simulatorSetup.active.temp_units) {
			return parseFloat(temperature);
		}

		return (parseFloat(temperature) * 1.8) + 32;
	},

	fahrenheitToCelsius(temperature) {
		if (! temperature) return temperature;

		if (store.state.simulatorSetup.active.temp_units) {
			return parseFloat(temperature);
		}

		return (parseFloat(temperature) - 32) * (5/9);
	},

	sugarUnit() {
		return store.state.simulatorSetup.active.sugar_units ? 'Be&deg;' : '&deg;Bx';
	},

	secondarySugarUnit() {
		return store.state.simulatorSetup.active.secondary_sugar_units == 'sg' ? 'SG' : 'RS (g/L)';
	},

	temperatureUnit() {
		return store.state.simulatorSetup.active.temp_units ? '&deg;C' : '&deg;F';
	}
}



// WEBPACK FOOTER //
// ./src/utils/units.js